import React from 'react';
import PropTypes from 'prop-types';
import './FeaturesItem.scss';
import { Checkmark } from 'components/svg';
import { Text , Paragraph } from 'components/core/Typography';

const FeaturesItem = ({ featuresData = [] }) => {

	const renderFeatureSection = (section) => (
		<div className="features-section" key={section.title}>
			{section.title && <Paragraph className="features-title">{section.title.toUpperCase()}</Paragraph>}
			<ul className="features-list">
				{section.content.map((feature, index) => (
					<li key={index} className={`feature-item ${feature.hasAttribute ? 'has-feature' : 'no-feature'}`}>
						{feature.hasAttribute && (
							<div className="amenity">
								<Checkmark />
								<Text>{feature.label}</Text>
							</div>
						)}
					</li>
				))}
			</ul>
		</div>
	);

	if (!featuresData || !Array.isArray(featuresData)) {
		return <div>No features data available</div>;
	}

	// Check if all features have hasAttribute === false
	const allFeaturesFalse = featuresData.every(section =>
		Array.isArray(section.content) && section.content.every(feature => !feature.hasAttribute)
	);

	if (allFeaturesFalse) {
		return <div>No data found</div>;
	}

	return (
		<div className="features-container">
			<div className="features-grid">
				{featuresData.map((section, index) => 
					renderFeatureSection(section)
				)}
			</div>
		</div>
	);
};

FeaturesItem.propTypes = {
	featuresData: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			content: PropTypes.arrayOf(
				PropTypes.shape({
					rank: PropTypes.number,
					label: PropTypes.string.isRequired,
					key: PropTypes.string.isRequired,
					hasAttribute: PropTypes.bool.isRequired
				})
			).isRequired
		})
	)
};

export default FeaturesItem;
